import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { MutableRefObject, PropsWithChildren } from 'react';

export type SingleFilterMenuProps = PropsWithChildren<{
  name: string;
  subName?: string;
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  innerPopoverOpenRef: MutableRefObject<boolean>;
}>;

export const SingleFilterMenu = (props: SingleFilterMenuProps) => {
  const { children, name, subName, anchorEl, open, onClose, innerPopoverOpenRef } = props;

  return (
    <Popover
      open={open}
      onClose={(_event, reason) => {
        if (innerPopoverOpenRef.current && reason === 'backdropClick') return;
        innerPopoverOpenRef.current = false;
        onClose();
      }}
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
    >
      <Box sx={{ minWidth: 340 }} data-test={`single-filter-menu-${name.toLowerCase()}`}>
        <Box
          sx={theme => ({
            alignItems: 'center',
            borderBottom: `1px solid ${theme.palette.divider}`,
            display: 'flex',
            justifyContent: 'space-between',
            padding: theme.spacing(1, 2),
          })}
        >
          <Typography variant="h3">
            {name}
            {subName && (
              <Typography
                component="span"
                sx={{
                  color: 'text.disabled',
                  fontWeight: 'normal',
                  fontSize: 'inherit',
                  marginLeft: theme => theme.spacing(0.5),
                }}
              >
                ({subName})
              </Typography>
            )}
          </Typography>

          <IconButton
            aria-label="close button icon"
            data-test="close-button"
            sx={{
              height: 28,
              padding: 0,
              width: 28,
            }}
            size="large"
            onClick={onClose}
          >
            <Close />
          </IconButton>
        </Box>

        <Stack
          direction="column"
          spacing={2}
          data-test="single-filter-menu-content"
          sx={{
            padding: theme => theme.spacing(3, 2),
          }}
        >
          {children}
        </Stack>
      </Box>
    </Popover>
  );
};
